import React from 'react'
import '../../styles/AdvisorCardsModule/AdvisorStat.scss'
import { Tooltip } from '../../components/Tooltip/Tooltip'
import infoIcon from '../../../static/images/info-icon.svg'

interface AdvisorStatProps {
  label: string
  value: string
  tooltip?: string
}

export const AdvisorStat = ({ label, value, tooltip }: AdvisorStatProps) => (
  <div className='advisor-stat'>
    <p className='advisor-stat__label'>
        {label}
        {tooltip && <Tooltip content={tooltip}><img src={infoIcon} alt='info'/></Tooltip>}
    </p>
    <p className='advisor-stat__value'>{value}</p>
  </div>
)
